import type { TagVariant } from '@volvo/vcdk';
import type { SystemIconId } from '@volvo/vcdk-assets';

export interface IInstallableCampaign {
  unitId: number;
  chassisSeries: string;
  chassisNumber: string;
  campaignCode: string;
  status: IInstallableCampaignStatus;
  statusTimestamp: string;
  errorCode: string | null;
  expirationDate: string;
  estimatedTime: number;
  campaignInformation: string;
  affectedNodes: IAffectedNode[];
}

interface IAffectedNode {
  nodeFamily: number;
  nodeType: number;
  nodePosition: number;
}

export type IInstallableCampaignStatus =
  | 'Activation sent' // code 1
  | 'Ready for activation - Failed' // code 2
  | 'Critical failure - Software recalled' // code 3
  | 'Ready for activation - Critical failure' // code 12
  | 'Critical failure' // code 21
  | 'Recalled' // code 26
  | 'Programming' // code 45
  | 'Sending' // code 57
  | 'Completed' // code 123
  | 'Failed' // code 275
  | 'Successful' // code 364
  | 'Connectivity Failed' // code 493
  | 'Ready for activation'; // code 523

export const PERFORMED_CAMPAIGN_STATUSES = new Set(['Performed', 'Completed', 'Successful']);
export const HIDDEN_CAMPAIGN_STATUSES = new Set(['Sending']);
export const RETRYABLE_ERROR_STATUSES = new Set<IInstallableCampaignStatus>([
  'Ready for activation - Failed',
  'Ready for activation - Critical failure',
]);

export const BLUE_DOT_STATUSES = new Set<IInstallableCampaignStatus>([
  'Activation sent',
  'Programming',
  'Ready for activation',
  'Ready for activation - Critical failure',
  'Ready for activation - Failed',
]);

export interface GoToNativeConfig {
  text: string;
  iconStart?: SystemIconId;
  iconEnd?: SystemIconId;
  statusText?: string;
  statusVariant?: TagVariant;
}

export const GO_TO_NATIVE_STATUSES = new Map<IInstallableCampaignStatus, GoToNativeConfig>([
  ['Activation sent', { text: 'See more', statusText: 'Installation in progress', statusVariant: 'success' }],
  ['Critical failure', { text: 'See more', statusText: 'Installation failed', statusVariant: 'error' }],
  ['Failed', { text: 'See more', statusText: 'Installation failed', statusVariant: 'error' }],
  ['Programming', { text: 'See more', statusText: 'Installation in progress', statusVariant: 'success' }],
  ['Ready for activation', { text: 'Install', iconStart: 'software-update' }],
  [
    'Ready for activation - Critical failure',
    { text: 'Try again', statusText: 'Installation failed', statusVariant: 'error' },
  ],
  ['Ready for activation - Failed', { text: 'Try again', statusText: 'Installation failed', statusVariant: 'error' }],
]);
